module.exports = __webpack_public_path__ + "static/landing@2x-bda13208bb66e0520ff105860ed1bfff.png";